import {default_params, default_hygienic_measurement, default_result, default_params_results} from './state';

/**
 * Establecer un valor para la variable hygienic_measurements.
 */
export function setHygienicMeasurements(state, hygienic_measurements) {
    state.hygienic_measurements = hygienic_measurements;
}

/**
 * Establecer un valor para la variable hygienic_measurement.
 */
export function setHygienicMeasurement(state, hygienic_measurement) {

    let positions = [];

    if (hygienic_measurement.positions) {
        hygienic_measurement.positions.map((position) => {
            positions.push(position.wor_position_id);
        });
    }

    hygienic_measurement.positions = positions;

    state.hygienic_measurement = hygienic_measurement;
}

/**
 * Establecer un valor para el atributo code de la variable hygienic_measurement.
 */
export function setCodeToHygienicMeasurement(state, code) {
    state.hygienic_measurement.code = code;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable companies.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Establecer el valor por defecto de params.
 */
export function resetParams(state) {
    state.params = default_params();
    state.hygienic_measurements = {data: []};
}

/**
 * Establecer el valor por defecto de params.
 */
export function resetParamsResults(state) {
    state.params_results = default_params_results();
    state.results = {data: []};
}

/**
 * Establecer el valor por defecto de hygienic_measurement.
 */
export function resetHygienicMeasurement(state) {
    state.hygienic_measurement = default_hygienic_measurement();
}

/**
 * Establecer el valor por defecto de result.
 */
export function resetResult(state) {
    state.result = default_result();
}

/**
 * Establecer un valor para el atributo show la variable modal.
 */
export function setModalShow(state, show) {
    //state.hygienic_measurement = default_hygienic_measurement();
    state.modal.show = show;
}

/**
 * Restablecer el valor del atributo page de la variable params.
 */
export function resetPageParams(state) {
    state.params.page = 1;
}

/**
 * Restablecer el valor del atributo page de la variable params.
 */
export function resetPageParamsResults(state) {
    state.params_results.page = 1;
}

/**
 * Establecer un valor para la variable types.
 */
export function setTypes(state, types) {
    state.types = types;
}

/**
 * Establecer un valor para el atributo show de la variable modal_attachments.
 */
export function setShowToModalAttachments(state, show) {
    state.modal_attachments.show = show;
}

/**
 * Establecer un valor para el atributo show de la variable modal_new_attachment.
 */
export function setShowToModalNewAttachment(state, show) {
    state.modal_new_attachment.show = show;
}

/**
 * Establecer un valor para la variable attachments.
 */
export function setAttachments(state, attachments) {
    state.attachments = attachments;
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function setStepToModal(state, step) {
    state.modal.step = step;
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function increaseStepToModal(state) {
    state.modal.step++;
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function decreaseStepToModal(state) {
    state.modal.step--;
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function addStep(state) {
    let order = 0;

    state.hygienic_measurement.steps.map(s => {
        if (s.order > order) {
            order = s.order;
        }
    });

    state.hygienic_measurement_step.id = (Math.floor(Math.random() * 10000) + 1) * -1;

    state.hygienic_measurement_step.order = order + 1;

    state.hygienic_measurement.steps.push(state.hygienic_measurement_step);
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function updateStep(state) {
    state.hygienic_measurement.steps.map(s => {
        if (state.hygienic_measurement_step.id === s.id) {
            s = state.hygienic_measurement_step;
        }
    });
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function addControl(state) {
    state.hygienic_measurement_control.id = (Math.floor(Math.random() * 10000) + 1) * -1;

    state.hygienic_measurement_control.sys_list_type = state.types.find(t => t.id === state.hygienic_measurement_control.sys_list_type_id);

    state.hygienic_measurement.controls.push(state.hygienic_measurement_control);
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function updateControl(state) {
    state.hygienic_measurement.controls.map(s => {
        if (state.hygienic_measurement_control.id === s.id) {
            s = state.hygienic_measurement_control;
        }
    });
}

/**
 * Establecer un valor para el atributo steps de la variable hygienic_measurement.
 */
export function setStepsToHygienicMeasurement(state, steps) {
    state.hygienic_measurement.steps = steps;
}

/**
 * Establecer un valor para la variable hygienic_measurement_step.
 */
export function setHygienicMeasurementStep(state, hygienic_measurement_step) {
    state.hygienic_measurement_step = hygienic_measurement_step;
}

/**
 * Establecer un valor para la variable hygienic_measurement_control.
 */
export function setHygienicMeasurementControl(state, hygienic_measurement_control) {
    state.hygienic_measurement_control = hygienic_measurement_control;
}

/**
 * Establecer un valor para el atributo controls de la variable hygienic_measurement.
 */
export function setControlsToHygienicMeasurement(state, controls) {
    state.hygienic_measurement.controls = controls;
}

/**
 * Establecer un valor para el atributo url de la variable hygienic_measurement.
 */
export function setUrlToHygienicMeasurement(state, url) {
    state.hygienic_measurement.url = url;

    if (!url) {
        state.hygienic_measurement.image = null;
    }
}

/**
 * Establecer un valor para el atributo url de la variable hygienic_measurement_step.
 */
export function setUrlToHygienicMeasurementStep(state, url) {
    state.hygienic_measurement_step.url = url;

    if (!url) {
        state.hygienic_measurement_step.image = null;
    }
}

/**
 * Establecer un valor para el atributo url de la variable hygienic_measurement_control.
 */
export function setUrlToHygienicMeasurementControl(state, url) {
    state.hygienic_measurement_control.url = url;

    if (!url) {
        state.hygienic_measurement_control.image = null;
    }
}

/**
 * Establecer un valor para la variable editing_control.
 */
export function setEditingControl(state, editing_control) {
    state.editing_control = editing_control;
}

/**
 * Establecer un valor para la variable editing_step.
 */
export function setEditingStep(state, editing_step) {
    state.editing_step = editing_step;
}

/**
 * Establecer un valor para la variable modal_image.
 */
export function setModalImage(state, modal_image) {
    state.modal_image = modal_image;
}

/**
 * Establecer un valor para la variable positions.
 */
export function setPositions(state, positions) {
    state.positions = positions;
}

/**
 * Establecer un valor para la variable results.
 */
export function setResults(state, results) {
    state.results = results;
}

/**
 * Establecer un valor para la variable result.
 */
export function setResult(state, result) {
    state.result = result;
}

/**
 * Establecer un valor para el atributo show de la variable modal_result.
 */
export function setShowToModalResult(state, show) {
    state.modal_result.show = show;
}

/**
 * Establecer un valor para el atributo show de la variable modal_results.
 */
export function setShowToModalResults(state, show) {
    state.modal_results.show = show;
}

/**
 * Establecer un valor para la variable editing_result.
 */
export function setEditingResult(state, editing_result) {
    state.editing_result = editing_result;
}

/**
 * Establecer un valor para la variable components.
 */
export function setComponents(state, components) {
    state.components = components;
}
